export function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const loginUrl = "https://unproxy.susu.ru";

export const roleClaim = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

function IsUserInRole(role) {
    var data = localStorage.getItem('auth_token');
    if (data == null || data == undefined)
        return false;
    var jwtData = parseJwt(data);

    var userRoles = [];
    if ((typeof jwtData[roleClaim]) == 'string') {
        userRoles.push(jwtData[roleClaim])
    } else {
        userRoles.push(...jwtData[roleClaim])
    }

    return userRoles.some(c => c == role);
}

/**
 * Проверяет есть ли у пользователя данная роль/роли
 * @param {string} roles - Роли пользователя
 * @returns {boolean}
 */
export function UserIsInRole(...roles){
    if(process.env.VUE_APP_AUTHORIZE_NEEDED=="false")
        return true;

    if(typeof roles=='string')
        return IsUserInRole(roles);

    return roles.some(c=>IsUserInRole(c));
}